import moment from 'moment';

import {DownloadMode} from 'common/report/constants';
import {getDownloadMode, isDigestMode, isTvMode} from 'common/report/util';
import {userCookieUtils} from 'common/report/util/user-identity-from-cookie';
import {featureSamplingUtils} from 'common/report/util/feature-sampling';

let initialized = false;

// enable hotjar for 10% of the user based on day of the year
export function isHotJarEnabled() {
  // enable 10% of the user together with day of year for hashing
  const userId = userCookieUtils.getUserIdentityFromCookie()?.id;
  return userId && featureSamplingUtils.determineFeatureEligibility(`${userId}${moment().dayOfYear()}`, `hotjar`, 10);
}

export async function trackHotjarEvent(eventName: string) {
  if (!initialized) {
    await initHotjar();
  }

  // @ts-ignore
  window.hj?.(`event`, eventName);
}

export async function hotjarIdentify(props) {
  if (!initialized) {
    await initHotjar();
  }

  const userIdentity = userCookieUtils.getUserIdentityFromCookie();
  // @ts-ignore
  window.hj?.(`identify`, userIdentity.id, props);
}

export async function initHotjar() {
  if (
    !userCookieUtils.getUserIdentityFromCookie() ||
    getDownloadMode() !== DownloadMode.None ||
    isDigestMode() ||
    isTvMode() ||
    !window.gdprData ||
    initialized
  ) {
    initialized = true;
    return;
  }

  const gdprData = window.gdprData;
  await gdprData.waitUntilReady();
  if (!gdprData.allowSnippets || !gdprData.allowTracking) {
    initialized = true;
    return;
  }

  // prettier-ignore
  // @ts-ignore
  // eslint-disable-next-line
  (function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:2879837,hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');

  const userIdentity = userCookieUtils.getUserIdentityFromCookie();
  // @ts-ignore
  window.hj(`identify`, userIdentity.id, {email: userIdentity.email});

  initialized = true;
}
